import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

const ProjectHoursDialog = ({ open, onClose, projectHoursData }) => {
  const remaining = (
    parseFloat(projectHoursData?.yearStart || 0) -
    parseFloat(projectHoursData?.ytdUsed || 0)
  ).toFixed(2);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      sx={{}}
    >
      <DialogTitle>ECI Hours Balance</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 0.5, mb: 2, color: 'text.secondary' }}>
          ECI mandates each employee works 1880 hours annually. The hours shown reflect the year to date total hours worked and are not associated with hours allocated on your prime contract.
        </Typography>
        <Grid container spacing={2} sx={{ py: 2 }}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Year Start"
              type="number"
              fullWidth
              value={projectHoursData?.yearStart || '0'}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="YTD Used"
              type="number"
              fullWidth
              value={projectHoursData?.ytdUsed || '0'}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Remaining"
              type="number"
              fullWidth
              value={remaining}
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectHoursDialog;
